import React, { ReactNode } from 'react';

import WizardStepHeader from './WizardStepHeader';
import { WizardStep } from './wizardState';

interface WizardChromeProps {
  /** Current step. */
  step: WizardStep;
  /** Big-text title for this step. Falls back to STEP_LABELS[step]. */
  title?: string;
  /** Optional subline under the title — usually a short instruction. */
  subtitle?: string;
  /** Step body. */
  children: ReactNode;
  /** Back button — omit to render no back affordance. */
  onBack?: () => void;
  backLabel?: string;
  /** Next button — omit to render no next affordance. */
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextHint?: string;
  hideNext?: boolean;
  steps?: readonly WizardStep[];
}

export default function WizardChrome({
  step, title, subtitle, children,
  onBack, backLabel = 'Back',
  onNext, nextLabel = 'Next →', nextDisabled = false, nextHint,
  hideNext = false, steps: stepsList,
}: WizardChromeProps) {
  return (
    <div className="wizard">
      <WizardStepHeader step={step} title={title} steps={stepsList} />
      {subtitle && <p className="wizard-subtitle muted">{subtitle}</p>}

      <div className="wizard-body">{children}</div>

      {/* Pinned to the bottom of the viewport so it's always reachable
          without scrolling. The inner wrapper handles centering +
          max-width so the buttons stay aligned with the rest of the
          wizard's 720px column. Back pinned left, primary pinned
          right — consistent layout on every step. */}
      <footer className="wizard-foot">
        <div className="wizard-foot-inner">
          {onBack ? (
            <button type="button" className="ghost btn--sm" onClick={onBack}>
              ← {backLabel}
            </button>
          ) : <span />}
          {onNext && !hideNext ? (
            <div className="wizard-foot-right">
              {nextHint && nextDisabled && (
                <span className="muted wizard-hint">{nextHint}</span>
              )}
              <button
                type="button"
                className="primary btn--sm"
                onClick={onNext}
                disabled={nextDisabled}
                title={nextDisabled ? nextHint : undefined}
              >
                {nextLabel}
              </button>
            </div>
          ) : <span />}
        </div>
      </footer>
    </div>
  );
}
